(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beautiful-pdp-enhancements"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pdpEnhancementTabsV4Bound) return;
    window.__pdpEnhancementTabsV4Bound = true;

    function getRoot(el) {
      return el ? el.closest('[data-pdp-enh]') : null;
    }

    function getTarget(tab, root) {
      if (!tab || !root) return null;
      var targetId = tab.getAttribute('data-target');
      if (!targetId) return null;
      var target = document.getElementById(targetId);
      if (!target || !root.contains(target)) return null;
      return target;
    }

    function getOffset(root) {
      var nav = root.querySelector('[data-pdp-nav]');
      if (!nav) return 16;
      var styles = window.getComputedStyle(nav);
      var stickyTop = parseFloat(styles.top);
      if (isNaN(stickyTop)) stickyTop = 0;
      return stickyTop + nav.getBoundingClientRect().height + 18;
    }

    function setActive(root, targetId, centreTab) {
      var tabs = root.querySelectorAll('[data-pdp-tab]');
      var scroller = root.querySelector('.pdp-enh__nav-scroll');

      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-target') === targetId;
        tab.classList.toggle('is-active', isActive);

        if (isActive) {
          tab.setAttribute('aria-current', 'true');
          if (centreTab && scroller) {
            var left = tab.offsetLeft - (scroller.clientWidth - tab.offsetWidth) / 2;
            scroller.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        } else {
          tab.removeAttribute('aria-current');
        }
      });
    }

    function scrollToTarget(root, target) {
      var offset = getOffset(root);
      target.style.scrollMarginTop = offset + 'px';
      if (typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        return;
      }
      var y = window.pageYOffset + target.getBoundingClientRect().top - offset;
      window.scrollTo(0, Math.max(0, y));
    }

    document.addEventListener(
      'click',
      function (event) {
        var clicked = event.target;
        if (!clicked || !clicked.closest) return;
        var tab = clicked.closest('[data-pdp-tab]');
        if (!tab) return;
        var root = getRoot(tab);
        if (!root) return;
        var target = getTarget(tab, root);
        if (!target) return;
        event.preventDefault();
        setActive(root, target.id, true);
        scrollToTarget(root, target);
      },
      true
    );

    var ticking = false;

    function updateActiveTabs() {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(function () {
        document.querySelectorAll('[data-pdp-enh]').forEach(function (root) {
          var nav = root.querySelector('[data-pdp-nav]');
          var panels = root.querySelectorAll('[data-pdp-panel]');
          if (!nav || !panels.length) return;

          var activationLine = nav.getBoundingClientRect().bottom + 24;
          var current = panels[0];

          panels.forEach(function (panel) {
            if (panel.getBoundingClientRect().top <= activationLine) current = panel;
          });

          if (current) setActive(root, current.id, false);
        });
        ticking = false;
      });
    }

    window.addEventListener('scroll', updateActiveTabs, { passive: true });
    document.addEventListener('scroll', updateActiveTabs, true);
    window.addEventListener('resize', updateActiveTabs, { passive: true });
    updateActiveTabs();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
